import React from "react";

export default function Line() {
  return <hr style={{ width: "100%", border: "1px solid rgba(0,0,0,0.25)" }} />;
}
